/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Button, Row, Col, Input, Spin, message, Form } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

// import ProceedModal from "./proceedModal";

import {
  clearCreatePackets,
  createPackets,
  getEligiblePackets,
  updatePacketStatus,
} from "../../../actionsMethods/manifestMethods";
import { capitalize, checkNumbervalue } from "../../../utils";

import packetIcon from "../../../assests/images/packetIcon.svg";
import HubIcon from "../../../assests/images/HubIcon.svg";
import weightIcon from "../../../assests/images/weightLogo.svg";
import countIcon from "../../../assests/images/countLogo.svg";
import guideIcon from "../../../assests/images/guide.svg";
import checkIcon from "../../../assests/images/SVG/check.svg";
import crossIcon from "../../../assests/images/redCross.svg";
import packetContents from "../../../assests/images/packetContents.svg";
import shipmentTruck from "../../../assests/images/SVG/packetSurface.svg";
import planeIcon from "../../../assests/images/planeicon.svg";

import noPacketsIcon from "../../../assests/images/SVG/nopackets.svg";

import "./style.scss";
import Heading from "../../../components/Heading";
import API from "../../../api";
import { APIs } from "../../../utils/worker";
// import BarcodeScanner from "../barcodeScanner";

const Packeting = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const inputRef = useRef(null);

  const [manifestFor, setManifestFor] = useState();
  const [scannedIndex, SetScannedIndex] = useState();
  const [packetIdInput, setpacketIdInput] = useState();
  const [enableInput, setenableInput] = useState(true);
  const [selectedCard, setselectedCard] = useState(true);
  const [currentScanNum, setcurrentScanNum] = useState([]);
  const [scannedNumbers, setScannedNumbers] = useState([]);
  const [packetIdSuccess, setPacketIdSuccess] = useState(false);
  const [successModalvisible, setSuccessModalvisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const [premiseId, setPremiseId] = useState(
    JSON.parse(localStorage.getItem("userId"))
  );

  const getEligiblePacketsResponse = useSelector(
    (state) => state.manifestReducer.getEligiblePacketsReducer,
    shallowEqual
  );

  const getCreatePacketsResponse = useSelector(
    (state) => state.manifestReducer.createPacketsReducer,
    shallowEqual
  );

  const {
    error: createPacketError,
    fetching: createPacketLoading,
    result: createPacketsResult,
  } = getCreatePacketsResponse;

  const {
    error: EligibleError,
    fetching: EligibleLoading,

    result: allPackets,
  } = getEligiblePacketsResponse;

  var allPackets2 = {
    packetBarcodes: [
      23300000050, 23300001301, 23300001302, 23300001303, 23300001304,
      23300001305, 23300001306, 23300001307, 23300001308, 23300001309,
      23300001310, 23300001311, 23300001312, 23300001313, 23300001314,
      23300001315, 23300001316, 23300001317, 23300001318, 23300001319,
      23300001320, 23300001321, 23300001322, 23300001323, 23300001324,
      23300001325, 23300001326, 23300001327, 23300001328, 23300001329,
      23300001330, 23300001331, 23300001332, 23300001333, 23300001334,
      23300001335, 23300001336, 23300001337, 23300001338, 23300001339,
      23300001340, 23300001341, 23300001342, 23300001343, 23300001344,
      23300001345, 23300001346, 23300001347, 23300001348, 23300001349,
      23300001350, 23300001351, 23300001352, 23300001353, 23300001354,
      23300001355, 23300001356, 23300001357, 23300001358, 23300001359,
      23300001360, 23300001361, 23300001362, 23300001363, 23300001364,
      23300001365, 23300001366, 23300001367, 23300001368, 23300001369,
      23300001370, 23300001371, 23300001372, 23300001373, 23300001374,
      23300001375, 23300001376, 23300001377, 23300001378, 23300001379,
      23300001380, 23300001381, 23300001382, 23300001383, 23300001384,
      23300001385, 23300001386, 23300001387, 23300001388, 23300001389,
      23300001390, 23300001391, 23300001392, 23300001393, 23300001394,
      23300001395, 23300001396, 23300001397, 23300001398, 23300001399,
      23300001400,
    ],
    createPacketDtos: [
      {
        packetBarcode: null,
        shipmentsAdded: [
          23490100000016, 23490100000015, 23490100000014, 23490200000192,
          23490200000191,
        ],
        shipmentsAddedWithWeight: null,
        service: "standard",
        travelBy: "air",
        toPremise: 114,
        weight: 1.15,
        status: null,
        premiseName: "RAJKOT HUB",
        packetingGuideName: "Delhi Gandhinagar-rajkot Hub",
      },
    ],
  };
  useEffect(() => {
    setManifestFor(localStorage.getItem("manifestFor"));
  }, [manifestFor]);

  useEffect(() => {
    let checkScanNum =
      filterCurrentAwbs && filterCurrentAwbs[0]?.includes(currentScanNum);
    if (checkScanNum) {
      if (scannedNumbers.includes(currentScanNum)) {
        return message.error("AWB No. already scanned");
      } else {
        setScannedNumbers((oldArray) => [
          ...oldArray,
          parseInt(currentScanNum),
        ]);
      }
    } else {
      if (scannedIndex !== undefined) {
        message.error("Awb number not found in current packet");
      }
    }
    if (scannedIndex === undefined) {
      SetScannedIndex(activepacket && activepacket[0]);
      setScannedNumbers((oldArray) => [...oldArray, parseInt(currentScanNum)]);
    }
  }, [currentScanNum]);

  useEffect(() => {
    if (createPacketError) {
      message.error(createPacketError.message);
      dispatch(clearCreatePackets());
    } else if (createPacketsResult) {
      message.success(
        `Packet with Id ${createPacketsResult?.packetBarcode} created`
      );
      createPacketsFun();
      setScannedNumbers([]);
      setcurrentScanNum([]);
      form.resetFields();
      setpacketIdInput("");

      dispatch(clearCreatePackets());
      dispatch(getEligiblePackets(manifestFor));
      setSuccessModalvisible(false);
      SetScannedIndex(undefined);
    }
  }, [createPacketError, createPacketsResult, scannedIndex]);

  useEffect(() => {
    // if (manifestFor) {
    dispatch(getEligiblePackets());
    // }
  }, []);

  useEffect(() => {
    if (allPackets && allPackets["createPacketDtos"]?.length === 0) {
      setselectedCard(false);
    } else {
      setselectedCard(true);
    }
  }, [allPackets]);

  useEffect(() => {
    if (currentScanNum.length === 0) {
      setenableInput(false);
    } else {
      setenableInput(true);
    }
  }, [scannedNumbers]);

  useEffect(() => {
    if (packetIdInput !== undefined) {
      if (packetIds?.includes(parseInt(packetIdInput))) {
        setPacketIdSuccess(true);
      } else {
        setPacketIdSuccess(false);
      }
    }
  }, [packetIdInput]);

  Array.prototype.twoDIndexOf = function (element) {
    if (this === null || this === undefined)
      throw TypeError("Array.prototype.indexOf called on null or undefined");
    for (let i = 0; i < this.length; i++) {
      const curr = this[i];
      if (curr?.includes(element)) return [i];
    }
    return -1;
  };

  const shipmentIdMap =
    allPackets &&
    allPackets &&
    allPackets["createPacketDtos"]?.map((val) => val?.shipmentsAdded);

  const packetIds = allPackets && allPackets && allPackets["packetBarcodes"];
  const activepacket = shipmentIdMap?.twoDIndexOf(parseInt(currentScanNum));

  const filterCurrentCard =
    allPackets &&
    allPackets &&
    allPackets["createPacketDtos"]?.filter((val, idx) => {
      return idx === scannedIndex;
    });

  const filterCurrentAwbs = filterCurrentCard?.map(
    (val) => val?.shipmentsAdded
  );

  const currentToPremise = filterCurrentCard?.map((val) => val?.toPremise);

  const filterTwoArrays = (arr1, arr2) => {
    return arr1?.filter((item) => !arr2.includes(item));
  };

  const unScannedAwbs = filterTwoArrays(
    filterCurrentAwbs && filterCurrentAwbs[0],
    scannedNumbers
  );

  const createPacketPayload = {
    packetBarcode: packetIdInput,
    service: filterCurrentCard && filterCurrentCard[0]?.service,
    travelBy:
      (allPackets &&
        allPackets["createPacketDtos"]?.map((val) => val.travelBy)[0]) ||
      "air",
    toPremiseId: currentToPremise && currentToPremise[0],
    fromPremiseId: premiseId?.userInfo?.premiseId,
    packetShipments: scannedNumbers
      ?.filter((val) => val === val)
      ?.map((val) => {
        if (val !== null) {
          return { awbNo: val };
        }
      }),
  };

  const handlecreatePackets = () => {
    if (unScannedAwbs.length > 0) {
      setSuccessModalvisible(true);
    } else {
      //setselectedCard(false);
      dispatch(createPackets(createPacketPayload));
      // createPacketsFun(createPacketPayload);
    }
    allPackets?.length === 0 && setselectedCard(false);
  };

  const createPacketsFun = async () => {
    setLoading(true);
    let response = await API.Api(
      `${APIs.baseURL}/v1/packets/hub/${packetIdInput}`
    ).putIdHeader(createPacketPayload);
    if (response.status) {
      setLoading(false);
      navigate("/dashboard");
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message || "Network error");
    }
  };

  const handleNext = () => {
    navigate("/bagging");
  };

  function closeSuccessModal() {
    setSuccessModalvisible(false);
  }

  function handleSuccessOk() {
    dispatch(createPackets(createPacketPayload));
  }

  let barcode = "";
  let interval;
  const handleKeyDown = (event) => {
    if (interval) clearInterval(interval);
    if (event.code == "Enter") {
      if (barcode) handleBarcode(barcode);
      barcode = "";
      return;
    }
    if (event.key != "Shift") barcode += event.key;
    interval = setInterval(() => (barcode = ""), 20);
  };
  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    // cleanup this component
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleBarcode = (scanned_barcode) => {
    setcurrentScanNum(parseInt(scanned_barcode));
    return scanned_barcode;
  };

  function onFinish() {
    handlecreatePackets();
  }

  const handleBack = () => {
    navigate("/dashboard");
  };

  return (
    <div className="p-2">
      <Heading title="Hub Packeting" />
      <Spin spinning={EligibleLoading || createPacketLoading || loading}>
        <div className="middle-mile-packet">
          {/* <ProceedModal
          visible={successModalvisible}
          handleCancel={closeSuccessModal}
          handleOk={handleSuccessOk}
          unScannedAwbs={unScannedAwbs}
        /> */}
          <div>
            <div className="container">
              <div className="content-header">
                <Row>
                  <Col lg={19}>All packets</Col>
                  <Col lg={5} align="end">
                    Total packet count:
                    <span>
                      {(allPackets && allPackets["createPacketDtos"]?.length) ||
                        0}
                    </span>
                  </Col>
                  <hr />
                </Row>
              </div>
              <div className="content-body">
                <Row align="center" className=" m-auto">
                  {allPackets &&
                  allPackets &&
                  allPackets["createPacketDtos"]?.length === 0 ? (
                    <p className={"no-packets"}>
                      {allPackets &&
                      allPackets &&
                      allPackets["createPacketDtos"]?.length === 0 ? (
                        <>
                          <Row>
                            <img
                              src={noPacketsIcon}
                              style={{ margin: "30px auto" }}
                            />
                          </Row>
                          <Row>{"No eligible packets to be packeted"}</Row>
                        </>
                      ) : (
                        EligibleError?.message
                      )}
                    </p>
                  ) : (
                    ""
                  )}

                  {allPackets &&
                    allPackets["createPacketDtos"]?.map((val, idx) => {
                      // console.log(idx, scannedIndex, "idx === scannedIndex");
                      // console.log(idx !== scannedIndex, "idx !== scannedIndex");

                      return (
                        <>
                          <Form onFinish={onFinish}>
                            <Col
                              lg={12}
                              md={12}
                              xs={24}
                              xl={12}
                              sm={24}
                              className={
                                idx === scannedIndex
                                  ? "active-cards cards"
                                  : "cards"
                              }
                            >
                              <Row>
                                <Col span={14}>
                                  <Row className="row-one">
                                    {" "}
                                    <img src={packetIcon} /> Packet Id
                                  </Row>
                                  <Row className="row-two">
                                    <Form.Item
                                      // label="Id"
                                      name={"PId"}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Id is required",
                                          validateTrigger: "onSubmit",
                                        },
                                        {
                                          min: 11,
                                          message: "Invalid Id",
                                          validateTrigger: "onSubmit",
                                        },
                                      ]}
                                      hasFeedback
                                      validateStatus={
                                        packetIdSuccess &&
                                        idx === scannedIndex &&
                                        packetIdInput?.length > 10
                                          ? "success"
                                          : !packetIdSuccess &&
                                            packetIdInput?.length > 10 &&
                                            idx === scannedIndex
                                          ? "error"
                                          : ""
                                      }
                                    >
                                      <Input
                                        // minLength={11}q
                                        disabled={idx !== scannedIndex}
                                        defaultValue={val?.packetBarcode}
                                        ref={inputRef}
                                        maxLength={11}
                                        onChange={(event) => {
                                          // SetScannedIndex(idx);
                                          // if (event.target.value.length > 10) {
                                          setpacketIdInput(event.target.value);
                                          // }
                                        }}
                                        onKeyPress={(event) => {
                                          // if (event.target.value.length > 9) {
                                          //   event.preventDefault();
                                          // }
                                          if (checkNumbervalue(event)) {
                                            event.preventDefault();
                                          }
                                        }}
                                      />
                                    </Form.Item>
                                  </Row>
                                </Col>
                                {/* <Col span={2}></Col> */}
                                <Col span={8}>
                                  <Row className="row-one">
                                    <Col span={23}>
                                      <img src={HubIcon} /> Hub
                                    </Col>
                                    <Col span={1}>
                                      {manifestFor === "air" ? (
                                        <img
                                          src={planeIcon}
                                          style={{ width: "25px" }}
                                        />
                                      ) : (
                                        <img
                                          src={planeIcon}
                                          style={{ width: "25px" }}
                                        />
                                      )}
                                    </Col>
                                  </Row>
                                  <Row className="row-two">
                                    {capitalize(allPackets?.parentHubName)}
                                  </Row>
                                </Col>
                              </Row>
                              <Row style={{ marginBottom: "16px" }}>
                                <Col span={8}>
                                  <Row className="row-one">
                                    {" "}
                                    <img src={weightIcon} /> Weight
                                  </Row>
                                  <Row className="row-two">
                                    {val?.weight?.toFixed(2)}kg
                                  </Row>
                                </Col>
                                <Col span={6}>
                                  <Row className="row-one">
                                    {" "}
                                    <img src={countIcon} /> Count
                                  </Row>
                                  <Row className="row-two">
                                    {val?.shipmentsAdded?.length}
                                  </Row>
                                </Col>
                                <Col span={10}>
                                  <Row className="row-one guide-name">
                                    {" "}
                                    <img src={guideIcon} />
                                    <span style={{ width: "70%" }}>
                                      Packeting guide name
                                    </span>
                                  </Row>
                                  <Row className="row-two">
                                    {val?.packetingGuideName}
                                  </Row>
                                </Col>
                              </Row>
                              <Row>
                                <Input
                                  style={{ width: "81%", margin: "10px auto" }}
                                  // defaultValue={val?.packetBarcode}
                                  disabled={idx !== scannedIndex && enableInput}
                                  maxLength={14}
                                  onChange={(e) => {
                                    // eslint-disable-next-line no-constant-condition
                                    if (e.target.value.length > 9) {
                                      setcurrentScanNum(
                                        parseInt(e.target.value)
                                      );
                                    }
                                  }}
                                />
                              </Row>

                              <Row className="row-one">
                                <Col span={12}>
                                  {" "}
                                  <img src={packetContents} /> Packet contents
                                </Col>
                              </Row>
                              <Row className="content-items">
                                <Col span={2}></Col>
                                <Col span={22}>
                                  <Row className="content-table-header">
                                    <Col span={15} className="awb-col">
                                      AWB No.
                                    </Col>
                                    <Col span={9}>Destination</Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row className="awb-destiny-row">
                                <Col span={2}></Col>
                                <Col className="awb-col-items" span={14}>
                                  {val?.shipmentsAdded?.map((awbNum, index) => {
                                    return (
                                      <p key={index}>
                                        {awbNum}
                                        {scannedNumbers.includes(awbNum) ? (
                                          <img src={checkIcon} />
                                        ) : (
                                          <img src={crossIcon} />
                                        )}
                                      </p>
                                    );
                                  })}
                                </Col>
                                <Col className="destination-col-items" span={8}>
                                  {val?.shipmentsAdded?.map((item, Pidx) => {
                                    return (
                                      <p key={Pidx}>
                                        {capitalize(val?.premiseName)}
                                      </p>
                                    );
                                  })}
                                </Col>
                              </Row>
                              <div className="close">
                                {idx === scannedIndex ? (
                                  <Button
                                    type="primary"
                                    htmlType="submit"
                                    // onClick={() =>
                                    //   handlecreatePackets(val?.toPremise)
                                    // }
                                    disabled={unScannedAwbs.length !== 0}
                                  >
                                    READY TO CLOSE
                                  </Button>
                                ) : null}
                              </div>
                            </Col>
                          </Form>
                        </>
                      );
                    })}
                </Row>
                {/* <Row className="submit">
                  <Button
                    // type="primary"
                    className=" cancel-btn mr-1"
                    // disabled={allPackets?.createPacketDtos?.length !== 0}
                    onClick={handleBack}
                  >
                    BACK
                  </Button>
                  <Button
                    type="submit"
                    className="save-btn"
                    // disabled={allPackets?.createPacketDtos?.length !== 0}
                    onClick={handleNext}
                  >
                    NEXT
                  </Button>
                </Row> */}
              </div>
            </div>
          </div>
        </div>
      </Spin>
    </div>
  );
};

export default Packeting;
